module.exports = __webpack_public_path__ + "static/Leaves Fall-ff1da3726f8eaad55a395332c176e6d8.jpg";